import React, { Dispatch, FC, useCallback } from 'react';
import { Col } from 'reactstrap';
import { DealerModel } from '../../../../shared/dealer';
import { Option, OptionDataValue } from '../../../../shared/options';
import { GenericOptionInput } from '../../../../shared/orders';
import { ProductOptionViewer } from '../../../components';
import { FormActionType } from '../../form/FormReducer';

interface DealerOptionProps {
  readonly applicationOnly: boolean;
  readonly required: boolean;
  readonly isApproved: boolean;
  readonly dealer: DealerModel;
  readonly setDealer: Dispatch<FormActionType>;
  readonly option: Option;
}

export const DealerOption: FC<DealerOptionProps> = ({
  applicationOnly,
  required,
  isApproved,
  option,
  setDealer,
  dealer,
}) => {
  const setOptionValue = useCallback(
    (id: number, value: OptionDataValue) => {
      setDealer({
        type: 'updateDealerOption',
        optionId: id,
        value,
      });
    },
    [setDealer],
  );

  // Adapt format
  const convertedOption: GenericOptionInput = {
    ...option,
    required,
    mutable: !applicationOnly,
  };

  const value = dealer.options[option.id];

  if (option.type === 'address') {
    return (
      <Col className="mb-1" key={option.id} xs={12}>
        <ProductOptionViewer
          defaultValue={value}
          disabled={applicationOnly && isApproved}
          onChange={setOptionValue}
          option={convertedOption}
        />
      </Col>
    );
  }

  return (
    <Col className="mb-1" key={option.id} lg={6} xs={12}>
      <ProductOptionViewer
        defaultValue={value}
        disabled={applicationOnly && isApproved}
        onChange={setOptionValue}
        option={convertedOption}
      />
    </Col>
  );
};
